import request from '@/utils/request'

export function listOrder (params) {
  return request({ url: '/order/list', method: 'get', params })
}

export function getOrder (id) {
  return request({ url: '/order/' + id, method: 'get' })
}

export function createOrder (data) {
  return request({ url: '/order', method: 'post', data })
}

export function updateOrder (data) {
  return request({ url: '/order/update', method: 'post', data })
}

export function refundOrder (id, data) {
  return request({ url: '/order/cancel/' + id, method: 'post', data })
}

export function cancelOrder (id) {
  return request({ url: '/order/cancel/' + id, method: 'post' })
}

export function changeOrderStatus (orderId, status, cancelReason, playStartTime, playEndTime) {
  return request({ url: '/order/status', method: 'post', params: { orderId, status, cancelReason, playStartTime, playEndTime } })
}

export function notifyOrder (lastId) {
  return request({ url: '/order/notify', method: 'get', params: { lastId } })
}
